import CurrentUserDrawer from "@/components/CurrentUserDrawer";
import { Close } from "@mui/icons-material";
import { AppBar, Box, IconButton, Toolbar, Typography } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function PageAppBar() {
  const navigate = useNavigate();
  const searchParams = useSearchParams()[0];
  const view = searchParams.get("view", "profile");

  const getTitle = () => {
    if (view === "billing") {
      return "manage billing";
    }
    return "my account";
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      style={{ background: "rgba(19,19,19,.9)" }}
    >
      <Toolbar
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <IconButton onClick={() => navigate("/")} sx={{ p: 0 }}>
            <Close />
          </IconButton>
        </Box>
        <Typography
          variant="h6"
          style={{
            fontFamily: "'Montserrat Alternates', sans-serif",
            fontWeight: 700,
            fontSize: "1.4rem",
            marginBottom: "0px",
            marginLeft: "12px",
          }}
        >
          {getTitle()}
        </Typography>
        <CurrentUserDrawer />
      </Toolbar>
    </AppBar>
  );
}
